import { FactoryFormsModule } from '@b2b/common/factories/forms/forms.factory';
import { ContentHeaderService, ContentHeaderServiceModule } from '@b2b/common/services/contentHeader';
import { TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

FormsPreviewController.$inject = [
  '$scope',
  '$filter',
  '$state',
  '$timeout',
  'ApiService',
  'HelpersService',
  'CalendarService',
  'ContentHeaderService',
  'UserPreferencesService',
  'FormsFactory',
];

function FormsPreviewController(
  $scope: IScope & { formsPreview: TODO },
  $filter: IFilterService,
  $state: StateService,
  $timeout: ITimeoutService,
  ApiService: TODO,
  HelpersService: TODO,
  CalendarService: TODO,
  ContentHeaderService: ContentHeaderService,
  UserPreferencesService: TODO,
  FormsFactory: TODO
) {
  const ctrl = {
    model: false as TODO | false,
    event: {
      name: $state.params.eventName,
      startTime: false,
      endTime: false,
    },

    init: function () {
      this.event.startTime = $state.params.eventStartTime
        ? $filter('date')(
            CalendarService.parseDate($state.params.eventStartTime),
            UserPreferencesService.getDateFormat('standardDateTime', 'dateFormat')
          )
        : '';
      this.event.endTime = $state.params.eventEndTime
        ? $filter('date')(
            CalendarService.parseDate($state.params.eventEndTime),
            UserPreferencesService.getDateFormat('standardDateTime', 'dateFormat')
          )
        : '';
      this.showHeader = this.checkShowHeader();
      ApiService.form.detail({ id: $state.params.formId }).then(this.success.init, this.error.init);
    },

    checkShowHeader: function () {
      return this.event.startTime && this.event.endTime && this.event.name;
    },

    close: function () {
      window.close();
    },

    success: {
      init: function (response) {
        const formsFactory = new FormsFactory();

        ctrl.model = response.data.payload;

        // Use this instead of $emit because application
        // $scope is no longer a parent
        ContentHeaderService.update({
          title: ctrl.model.name,
        });

        formsFactory.init();
        formsFactory.renderForm({
          containerId: 'forms-preview-container',
          customFields: [],
          sourceFormDefinition: ctrl.model.sourceFormDefinition,
        });
      },
    },

    error: {
      init: function (response) {},
    },
  };

  $scope.formsPreview = ctrl;
  ctrl.init();
}

export const FormsPreviewControllerModule = angular
  .module('acme.view.application.forms.preview.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.helpers',
    'acme.common.service.userPreferences',
    ContentHeaderServiceModule,
    FactoryFormsModule,
  ])
  .controller('FormsPreviewController', FormsPreviewController).name;
